import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { Contract } from '../../model/contract';
import { ContractService } from '../base/contract';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { Observable } from 'rxjs';

@Injectable()
export class PrintContractCommandHandler implements ICommandHandler {
  constructor(
    private _service: ContractService<Contract>,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    return command.id === leaseAgreementCommand.print && command.context;
  }

  execute(command: Command): Observable<void> {
    if (command instanceof Command) {
      return this._service
        .print(command.context.id)
        .pipe(map(res => this._nativeWindow.openFile(res, `${(<Contract>command.context).leaseAgreementNumber}.pdf`)));
    }
  }
}
